import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {RouterController} from "../../../core/components/router/router-controller";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {ACTION_TYPES, ROUTE_NAMES} from "../../../core/consts";
import {WebsiteModuleController} from "../website-module.controller";

export class WebsiteModuleGameContextChangeHandler extends BaseComponentLifecycleEventHandler {
  controller: WebsiteModuleController
  state: BaseMobxState;
  type = ACTION_TYPES.mainContentGame;

  static injectables = [...BaseComponentLifecycleEventHandler.injectables, RouterController];

  constructor(routerController: RouterController) {
    super();

    this.routerController = routerController;
    this.type = ACTION_TYPES.onChangeGameContext
  }

  onLoaded() {
    super.onLoaded();

    const validRoutes = [ROUTE_NAMES.allScores]
    this.routerController.registerToRouteChange(WebsiteModuleGameContextChangeHandler.name, () => {
      !validRoutes.includes(this.state.currentLinkModel.name) && this.removeGame()
    });
  }

  removeGame() {
    this.controller.action(ACTION_TYPES.onGameContextClose)
  }
}
